import apiClient from './apiClient';

class ActivityTracker {
    constructor() {
        this.lastActivityTime = Date.now();
        this.isTracking = false;
        this.intervalId = null;
        this.UPDATE_INTERVAL = 2 * 60 * 1000; // 2 minutes in milliseconds
        this.activityBuffer = 0; // Buffer to store activity time
    }

    startTracking() {
        if (this.isTracking) return;

        this.isTracking = true;
        this.lastActivityTime = Date.now();
        this.activityBuffer = 0;

        // Update every 2 minutes
        this.intervalId = setInterval(() => {
            this.flushActivityBuffer();
        }, this.UPDATE_INTERVAL);

        // Track continuous activity
        const trackActivity = () => {
            if (!this.isTracking) return;
            this.activityBuffer += 1; // Add 1 minute
            if (this.activityBuffer >= 2) { // Flush when buffer reaches 2 minutes
                this.flushActivityBuffer();
            }
        };

        // Check activity every minute
        setInterval(trackActivity, 60 * 1000);

        // Add activity listeners
        window.addEventListener('mousemove', this.handleActivity);
        window.addEventListener('keypress', this.handleActivity);
    }

    async flushActivityBuffer() {
        if (this.activityBuffer === 0) return;

        const userId = localStorage.getItem('userId');
        if (!userId) return;

        try {
            console.log(`Sending activity update: ${this.activityBuffer} minutes`);
            await apiClient.post(`/api/users/${userId}/screen-time`, {
                minutes: this.activityBuffer
            });
            this.activityBuffer = 0;
        } catch (error) {
            console.error('Error updating screen time:', error);
        }
    }

    handleActivity = () => {
        this.lastActivityTime = Date.now();
    };

    async stopTracking() {
        if (!this.isTracking) return;
        
        // Final update
        await this.flushActivityBuffer();
        
        this.isTracking = false;
        clearInterval(this.intervalId);
        window.removeEventListener('mousemove', this.handleActivity);
        window.removeEventListener('keypress', this.handleActivity);
    }
}

export default new ActivityTracker();